import React from 'react';

import useModal from 'hooks/useModal';
import { IContentsModule } from 'types';
import { TbPhotoPlus } from 'react-icons/tb';
import ImageSelector from './ImageSelector';
import { useTarget } from 'providers/target/useTarget';
interface Props {
  module: IContentsModule;
}

function EditImage({ module }: Props) {
  const { handleModal } = useModal();
  const { targetList, setTargetList } = useTarget();
  const fileUrl = module.data;

  const handleSelect = (url: string) => {
    setTargetList(
      targetList.map((i) => {
        if (i.id === module.id) {
          return { ...i, data: url };
        }
        return i;
      }),
    );
  };

  const handleClick = () => {
    handleModal('이미지 업로드', <ImageSelector handleSelect={handleSelect} />);
  };

  return (
    <>
      {fileUrl ? (
        <img
          src={fileUrl}
          alt="thumbnail"
          onClick={handleClick}
          style={{ cursor: 'pointer', maxWidth: '100%', height: 'auto' }}
        />
      ) : (
        <button
          type="button"
          onClick={handleClick}
          css={(theme) => ({
            width: '100%',
            minHeight: 200,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 8,
            border: `1.5px dashed ${theme.color.grey200}`,
            background: theme.color.grey50,
            color: theme.color.grey500,
            fontSize: 14,
            cursor: 'pointer',
            ':hover': {
              background: theme.color.grey75,
              color: theme.color.grey700,
            },
          })}
        >
          <TbPhotoPlus size={28} />
          이미지를 업로드해주세요
        </button>
      )}
    </>
  );
}

export default EditImage;
